import Header from '../.shared/header/header';
import Footer from '../.shared/footer/footer';
import LegitScriptBanner from '../.shared/LegitScriptBanner/LegitScriptBanner';
import AffiliateHero from './AffiliateHero';
import AffiliateVideo from './AffiliateVideo';
import AffiliateStats from './AffiliateStats';
import AffiliateDeck from './AffiliateDeck';
import AffiliateSignup from './AffiliateSignup';

const AFFILIATE_VIDEO_URL = 'https://www.youtube.com/embed/RVXoB-dF8us?rel=0&modestbranding=1';

function AffiliateLanding() {
    return (
        <>
            <Header hideNavigation={false} />
            <AffiliateHero />
            <AffiliateVideo videoUrl={AFFILIATE_VIDEO_URL} />
            <AffiliateStats />
            <AffiliateDeck />
            <AffiliateSignup />
            <LegitScriptBanner />
            <Footer />
        </>
    );
}

export default AffiliateLanding;
